import { Controller } from "@hotwired/stimulus"

// Показывает N полей для ручного ввода номеров палет по значению result_pallets (только в manual-режиме).
export default class extends Controller {
  static targets = ["resultCount", "numbersFields"]
  static values = { manual: Boolean }

  connect() {
    if (this.manualValue) this.renderNumberFields()
  }

  renderNumberFields() {
    if (!this.manualValue || !this.hasNumbersFieldsTarget) return

    const count = parseInt(this.resultCountTarget.value, 10) || 0
    const container = this.numbersFieldsTarget
    container.innerHTML = ""

    for (let i = 0; i < count; i++) {
      const input = document.createElement("input")
      input.type = "number"
      input.name = "processing[numbers][]"
      input.className = "form-control"
      input.style.width = "8rem"
      input.min = "1"
      input.placeholder = `№ ${i + 1}`
      container.appendChild(input)
    }
  }
}
